import { defineMessages } from 'react-intl.macro';

export default defineMessages({
  sectionTitle: {
    id: 'views.Presentations.ListView.title',
    defaultMessage: 'Prezentacje'
  }
});



// WEBPACK FOOTER //
// ./src/views/Presentations/PresentationsListView.intl.js